import FieldSet from '../../FieldSet';

import { DependenciesCount } from './DependenciesCount';

export class DependenciesFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [DependenciesCount];
  }

  get title() {
    return 'Dependencies';
  }
}
